import { IStore } from '..';
import { createSelector } from 'reselect';

const getScreenWidth = (state: IStore) => state.screen.width;
const getIsMobile = createSelector([ getScreenWidth ], (screenWidth) => screenWidth <= 1024 );

export { getIsMobile };


// WEBPACK FOOTER //
// ./src/store/Screen/selectors.tsx